(function () {
  'use strict';

  var overlay, imgEl, captionEl, counterEl, btnPrev, btnNext, btnClose;
  var galleryItems = [];
  var currentIndex = 0;
  var isOpen = false;
  var isTransitioning = false;
  var activeElement = null;
  var TRANSITION_DURATION = 300;

  function createOverlay() {
    var div = document.createElement('div');
    div.innerHTML =
      '<div class="lightbox-overlay" role="dialog" aria-label="Image lightbox" aria-modal="true">' +
        '<div class="lightbox-img-wrap">' +
          '<img src="" alt="">' +
        '</div>' +
        '<button type="button" class="lightbox-close" aria-label="Close">' +
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"></line>' +
            '<line x1="6" y1="6" x2="18" y2="18"></line>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="lightbox-prev" aria-label="Previous">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="15 18 9 12 15 6"></polyline>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="lightbox-next" aria-label="Next">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="9 6 15 12 9 18"></polyline>' +
          '</svg>' +
        '</button>' +
        '<div class="lightbox-bottom">' +
          '<span class="lightbox-caption"></span>' +
          '<span class="lightbox-counter"></span>' +
        '</div>' +
      '</div>';

    overlay = div.firstChild;
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('img');
    captionEl = overlay.querySelector('.lightbox-caption');
    counterEl = overlay.querySelector('.lightbox-counter');
    btnPrev = overlay.querySelector('.lightbox-prev');
    btnNext = overlay.querySelector('.lightbox-next');
    btnClose = overlay.querySelector('.lightbox-close');

    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); navigate(-1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); navigate(1); });
    btnClose.addEventListener('click', function () { hide(); });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('lightbox-img-wrap')) hide();
    });
  }

  function finishHide() {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    imgEl.classList.remove('lightbox-img-loaded');
    isOpen = false;
    isTransitioning = false;
    if (activeElement && activeElement.focus) {
      activeElement.focus();
      activeElement = null;
    }
  }

  function show() {
    if (isOpen) return;
    if (!overlay) createOverlay();
    activeElement = document.activeElement;
    document.body.style.overflow = 'hidden';
    overlay.style.display = 'flex';
    void overlay.offsetHeight;
    overlay.classList.add('lightbox-visible');
    isOpen = true;
    isTransitioning = false;
    btnClose.focus();
  }

  function hide() {
    if (!isOpen || isTransitioning) return;
    isTransitioning = true;
    overlay.classList.remove('lightbox-visible');

    function onDone(e) {
      if (e && (e.target !== overlay || e.propertyName !== 'opacity')) return;
      overlay.removeEventListener('transitionend', onDone);
      clearTimeout(fallback);
      finishHide();
    }

    overlay.addEventListener('transitionend', onDone);
    var fallback = setTimeout(function () {
      overlay.removeEventListener('transitionend', onDone);
      finishHide();
    }, TRANSITION_DURATION);
  }

  function showImage(index) {
    if (index < 0 || index >= galleryItems.length) return;
    currentIndex = index;
    var item = galleryItems[index];

    imgEl.classList.remove('lightbox-img-loaded');
    imgEl.onload = function () { imgEl.classList.add('lightbox-img-loaded'); };
    imgEl.onerror = function () { imgEl.classList.add('lightbox-img-loaded'); };
    imgEl.src = item.href;
    imgEl.alt = item.caption || '';

    captionEl.textContent = item.caption || '';
    captionEl.style.display = item.caption ? '' : 'none';

    var hasNav = galleryItems.length > 1;
    btnPrev.style.display = hasNav ? '' : 'none';
    btnNext.style.display = hasNav ? '' : 'none';
    counterEl.textContent = hasNav ? (index + 1) + ' / ' + galleryItems.length : '';
  }

  function navigate(dir) {
    var next = (currentIndex + dir + galleryItems.length) % galleryItems.length;
    showImage(next);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lightbox]');
    if (!link) return;
    e.preventDefault();

    var group = link.getAttribute('data-lightbox');
    if (group) {
      var links = document.querySelectorAll('[data-lightbox="' + group + '"]');
      galleryItems = [];
      links.forEach(function (el) {
        galleryItems.push({ href: el.href, caption: el.getAttribute('data-caption') || '' });
      });
      currentIndex = Array.prototype.indexOf.call(links, link);
    } else {
      galleryItems = [{ href: link.href, caption: link.getAttribute('data-caption') || '' }];
      currentIndex = 0;
    }

    show();
    showImage(currentIndex);
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') hide();
    else if (e.key === 'ArrowLeft') navigate(-1);
    else if (e.key === 'ArrowRight') navigate(1);
  });
})();
